import React from 'react';
import moment from 'moment';

interface Props {
  date: string;
  showTime?: boolean;
}

const MaterialTableDateColumn = ({ date, showTime }: Props) => {
  const format = showTime ? 'DD.MM.YYYY, hh:mm:ss' : 'DD.MM.YYYY';
  return <span>{moment(parseInt(date)).format(format)}</span>;
};

export default MaterialTableDateColumn;
